import React, { useState, useEffect, useCallback } from "react";
import { sendMessage, getSummary } from "../api/chat";

const ChatWindow = () => {
    const [messages, setMessages] = useState([]);
    const [input, setInput] = useState("");
    const [sessionId] = useState(`session_${Math.random().toString(36).substr(2, 9)}`);
    const [summary, setSummary] = useState(null);
    const [loading, setLoading] = useState(false);
    const [typingText, setTypingText] = useState(null);

    const handleStartConversation = useCallback(async () => {
        const text = "start_conversation";

        setLoading(true);
        const data = await sendMessage(text, sessionId);
        setLoading(false);

        const fullMessage = data.response;
        setTypingText("");

        let index = 0;
        const interval = setInterval(() => {
            setTypingText((prev) => {
                const next = fullMessage.slice(0, index + 1);
                if (index === fullMessage.length - 1) {
                    clearInterval(interval);
                    setMessages((prev) => [...prev, { role: "assistant", content: fullMessage }]);
                    setTypingText(null);
                }
                index++;
                return next;
            });
        }, 40);
    }, [sessionId]);

    const handleSend = async () => {
        const text = input.trim();
        if (!text) return;

        const userMessage = { role: "user", content: text };
        setMessages((prev) => [...prev, userMessage]);

        setLoading(true);
        const data = await sendMessage(text, sessionId);
        setLoading(false);

        const fullMessage = data.response;
        setTypingText("");

        let index = 0;
        const interval = setInterval(() => {
            setTypingText((prev) => {
                const next = fullMessage.slice(0, index + 1);
                if (index === fullMessage.length - 1) {
                    clearInterval(interval);
                    setMessages((prev) => [...prev, { role: "assistant", content: fullMessage }]);
                    setTypingText(null);
                }
                index++;
                return next;
            });
        }, 40);

        setInput(""); // reset input
    };

    useEffect(() => {
        const timer = setTimeout(() => {
            handleStartConversation();
        }, 1);
        return () => clearTimeout(timer);
    }, [handleStartConversation]);


    const handleGetSummary = async () => {
        setLoading(true);
        const data = await getSummary(sessionId);
        setLoading(false);
        setSummary(data.summary);
    };

    return (
    <div className="container card">
        <h1 className="heading">Link Real Estate</h1>
        
        {/* Value Proposition Added Here */}
        <p className="value-proposition mt-3 mb-4 text-center">
            Bienvenido al futuro de la búsqueda de propiedades. Olvídate de los filtros de los 90: simplemente dile a nuestra IA lo que buscas, y rastreará toda la web para encontrar tu hogar perfecto. Sin esfuerzo, inteligente, completo.
        </p>

        <div className="chat-box">
            {messages.map((msg, index) => (
                <div
                    key={index}
                    className={`message-bubble ${msg.role === "user" ? "user-message" : "assistant-message"}`}
                >
                    {msg.content}
                </div>
            ))}

            {typingText && (
                <div className="message-bubble assistant-message">
                    {typingText}
                    <span className="blinking-cursor">|</span>
                </div>
            )}
        </div>

        <input
            type="text"
            value={input}
            onChange={(e) => setInput(e.target.value)}
            onKeyDown={(e) => {
                if (e.key === "Enter") {
                    e.preventDefault();
                    handleSend();
                }
            }}
            placeholder="Type your message..."
            className="input mt-2"
        />

        <button onClick={() => handleSend()} className="button-primary mt-2" disabled={loading}>
            {loading ? "Sending..." : "Send"}
        </button>

        <button onClick={handleGetSummary} className="button-secondary mt-2">
            Get Summary
        </button>

        {summary && <p className="mt-4 p-3 bg-yellow-100 rounded-md">{summary}</p>}
    </div>
);
};

export default ChatWindow;

